// TODO: remove this in next major version
export var safeUnsubscribe = function safeUnsubscribe(subscription) {
  // eslint-disable-next-line no-console
  console.warn('safeUnsubscribe() is deprecated and will be removed in the next media-client major version');
  setTimeout(function () {
    return subscription && subscription.unsubscribe();
  }, 0);
};